import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import logo from "../../static/images/logo.svg";
import React, { Component } from "react";
import WOW from "wowjs";

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = { isToggle: false, isScrolled: false };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    this.setState({ isToggle: !this.state.isToggle });
  }

  componentDidMount() {
    window.addEventListener("scroll", this.listenToScroll);

    if (typeof window !== "undefined") {
      window.WOW = WOW;
    }
    new WOW.WOW().init();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.listenToScroll);
  }

  listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;

    const scrolled = winScroll / height;

    if (scrolled > 0) {
      this.setState({
        isScrolled: true,
      });
    } else {
      this.setState({
        isScrolled: false,
      });
    }
  };

  render() {
    return (
      <div className="sticky-top">
        <nav
          className={
            "navbar navbar-expanded-sm " +
            (this.state.isScrolled ? "floatingNav" : "") +
            (this.props.transparent ? "transparent" : "")
          }
        >
          <div className="container-fluid">
            <div className="navbar-brand wow zoomIn">
              <div className="row">
              <div className="col-md-12">
                <Link to="/">
                  <a>
                    <img
                        className="logo float-left"
                        src={logo}
                        alt="Master n Masters"
                    />

                  </a>
                </Link>
              </div>
              <div className="col-md-12">
                <small className='tagline'>Skill Excellence Through Edutainment  </small>
              </div>
              </div>

            </div>

            <div
              className={
                "collapse navbar-collapse " +
                (this.state.isToggle ? "show" : "")
              }
            >
              <ul
                className={
                  "navbar-nav ml-auto animated faster " +
                  (this.state.isToggle ? "fadeInRight" : "")
                }
              >
                <li className="nav-item">
                  <Link to="/">
                    <a>Home</a>
                  </Link>
                </li>
                <li className="nav-item">
                  <a href="/about">About</a>
                </li>
                <li className="nav-item">
                  <a href="/specialities">Focal Areas</a>
                </li>
                <li className="nav-item">
                  <a href="/certified">Courses</a>
                </li>
                <li className="nav-item">
                  <a href="/projects">Projects</a>
                </li>
                {/*<li className="nav-item">
                  <a href="/certified">Certified-Courses</a>
                </li>*/}

                {/* <li className="nav-item">
                  <a href="/competition">Art Competition</a>
                </li> */}

               {/* <li className="nav-item">
                  <a href="/gallery">Gallery</a>
                </li>*/}
                <li className="nav-item">
                  <Link to="/contact">
                    <a>Contact</a>
                  </Link>
                </li>

              </ul>
            </div>
            <div className="menu">
              <button
                className="navbar-toggler"
                type="button"
                onClick={this.handleClick}
              >
                <span className="navbar-toggler-icon" />
                {/* <img className="float-left wow zoomIn" src={menuIcon} /> */}
              </button>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

export default Navbar;
